import Inventory from './container'

export default Inventory